import React from 'react';
import { useIntl } from 'react-intl';
import { pathSlash } from 'lib/url';

import { Link } from 'gatsby';
import { Row, Column, Grid } from 'src/components/Grid';
import { type Target } from './types';

import cn from 'clsx';
import * as css from './NextPrevious.module.scss';

type ButtonProps = {
    header: string;
    target: Target;
    className?: string;
};
function Button({ header, target, className }: ButtonProps) {
    return (
        <Column className={cn(css.link, className)} colLg={6} colMd={4} colSm={2}>
            <Link to={pathSlash(target.to, true)}>
                <div className={css.direction} children={header} />
                <div className={css.name} children={target.name} />
            </Link>
        </Column>
    );
}

type NextPreviousContainerProps = {
    previousItem: null | Target;
    nextItem: null | Target;
    isHomepage?: boolean;
};
export default function NextPreviousContainer({ previousItem, nextItem, isHomepage }: NextPreviousContainerProps) {
    const { formatMessage } = useIntl();

    return (
        <div className={cn(css.root, isHomepage && css.isHomepage)}>
            <Grid className={css.grid}>
                <Row className={css.linkContainer}>
                    {previousItem && (
                        <Button
                            target={previousItem}
                            className={css.previous}
                            header={formatMessage({ defaultMessage: 'Previous' })}
                        />
                    )}
                    {nextItem && <Button target={nextItem} header={formatMessage({ defaultMessage: 'Next' })} />}
                </Row>
            </Grid>
        </div>
    );
}
